import { Box, Card, CardBody, HStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { companyColors } from "../../global/companyColors";
import {
  CompanyAddress,
  CompanyContactDetails,
} from "../../generic/CompanyAddress";

export function GetInTouch({ variant }: { variant?: "simple" | "detailed" }) {
  const { t } = useTranslation();

  return (
    <Card
      borderLeftColor={companyColors.blue[600]}
      borderLeftWidth={4}
      bg={companyColors.blue[200]}
      w="250px"
      h={variant === "detailed" ? "184px" : undefined}
      /*  _hover={{ bg: "red" }} */
      mt={0}
    >
      <CardBody>
        <HStack spacing={3} alignItems={"flex-start"}>
          <Box>
            {variant === "detailed" && (
              <Box fontWeight={"600"} mb={6}>
                {t("getInTouch")}
              </Box>
            )}
            <CompanyContactDetails />
          </Box>
        </HStack>
      </CardBody>
    </Card>
  );
}
